import { render, staticRenderFns } from "./horizontalAlignLeft.vue?vue&type=template&id=71930d5a&"
import script from "./horizontalAlignLeft.vue?vue&type=script&lang=ts&"
export * from "./horizontalAlignLeft.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports